<template>
  <div
    class="w-full rounded-sm bg-op-90 text-sm c-white shadow-sm backdrop-blur-sm"
    :class="[
      classToast,
      { 'bg-red-30': type === 'error' },
      { 'bg-black': type === 'info' || !type },
      { 'bg-green-30': type === 'success' },
      { '-mt-4': variant },
      { 'shadow-xl px-2 py-4': !variant },
    ]"
    data-test-id="vf-toast"
  >
    <define-cta-group>
      <div v-if="ctas?.length">
        <vf-link
          v-for="({ label, to, click }, key) in ctas"
          :key
                    size="sm"
          :to
          @click="clickCta(click)"
        >
          {{ label }}
        </vf-link>
      </div>
    </define-cta-group>
    <template v-if="!variant">
      <div class="flex grow items-center gap-6">
        <div class="flex grow items-center gap-2">
          <vf-icon
            v-if="type || icon"
            class="shrink-0"
            :class="{ 'self-end': icon, 'hidden': hideIcon }"
            :name="type"
            :size="icon?.size || iconSize[$viewport.breakpoint]"
            :src="icon?.src"
          />
          <div v-if="title || message || ctas?.length" class="f-col grow gap-1" :class="classMessage">
            <p v-if="title" class="fw-bold">
              <base-interpolator :content="title">
                <template #uppercase="{ args: [message] }">
                  <span class="uppercase">
                    {{ message }}
                  </span>
                </template>
              </base-interpolator>
            </p>
            <p v-if="message">
              <base-interpolator :content="message">
                <template #bold="{ args: [message] }">
                  <span class="fw-bold">
                    {{ message }}
                  </span>
                </template>
              </base-interpolator>
            </p>
            <cta-group v-if="ctaPosition === 'bottom'" class="mt-2" />
          </div>
        </div>
        <cta-group v-if="ctaPosition === 'right'" />
        <base-button
          :aria-label="$t.close"
          @click="$emit('close')"
        >
          <vf-icon name="close" size="md" />
        </base-button>
      </div>
      <div v-if="bottomText" v-html="bottomText" class="mt-2 bg-grey-90 px-4 py-3 -mx-4 -mb-6" />
    </template>
    <template v-else>
      <Teleport to="body">
        <div class="absolute-0 z-overlay full" @click="$emit('close')" />
      </Teleport>
      <div class="relative pb-6 md:w-80" data-test-id="vf-toast" @click="$emit('close')">
        <div
          :class="classMessage"
          data-test-id="rewards-info-box"
          style="border-top-right-radius: 0; margin-top: -1px;"
        >
          <div class="text-md">
            {{ title }}
          </div>
          <div class="mt-4 flex">
            <vf-icon class="mr-4" :size="icon?.size" :src="icon?.src" />
            <div>
              <p class="fw-medium lh-none">
                {{ message }}
              </p>
              <p class="mt-2 ws-pre-wrap lh-tight">
                {{ bottomText }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { ToastProps } from '#types/notification'
import { VfLink } from '#components'

const { type = 'success', ctaPosition = 'bottom' } = defineProps<ToastProps>()

const emit = defineEmits<{
  close: []
}>()

const { iconSize } = useAppConfig().components.vf.toast

const [DefineCtaGroup, CtaGroup] = createReusableTemplate()

const clickCta = (ctaClickHandler?) => {
  ctaClickHandler?.()
  emit('close')
}
</script>
